export const handleChangeDataPageMain = (name, value) => ({
    type: 'CHANGE_DATA_PAGE_MAIN', name, value
});